/* eslint-disable max-classes-per-file */

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import onEnterPress from 'hb-react/shared/utils/onEnterPress';

import {
  availableServices,
  windowPopupSettings,
} from './SocialMediaButtons/helpers/socialMediaServices';

export const ShareButton = ({ social, className, shareUrl, url, title }) => {
  const handleClick = useCallback((event) => {
    const strParam = windowPopupSettings();

    event.preventDefault();
    event.stopPropagation();
    window.open(url, title, strParam.join(',')).focus();
  }, []);

  const anchorProps = {
    className: classNames(`icon-${social}`, className),
    onClick: handleClick,
    'data-testid': `share-${social}`,
    'data-url': shareUrl,
    onKeyPress: onEnterPress(handleClick),
    href: '',
    'aria-label': `${social} ${__('Share')}`,
  };

  return <Box fontSize={4} as="a" {...anchorProps} />;
};

ShareButton.propTypes = {
  className: PropTypes.string,
  shareUrl: PropTypes.string.isRequired,
  social: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
};

ShareButton.defaultProps = {
  className: '',
};

const ShareButtons = ({ url, title, ...rest }) => {
  const renderButtons = useMemo(
    () =>
      availableServices.map((social) => (
        <li
          key={social.name}
          className="inline-block v-middle soft-half--right"
        >
          <ShareButton
            {...social}
            {...rest}
            url={encodeURI(`${social.url + url}&text=${title}`)}
            shareUrl={url}
            title={title}
            social={social.name}
          />
        </li>
      )),
    [availableServices, url, title],
  );

  return <ul data-testid="share-buttons">{renderButtons}</ul>;
};

ShareButtons.propTypes = {
  title: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
};

export default ShareButtons;
